import { useNavigate } from 'react-router-dom';
import { GetCampaignParams } from '@features/campaigns';
import { stringify } from 'qs';
import { useCurrentUser } from '@features/users';
import { presentationToFile } from '@features/powerpoint';
import { GetLci3ReportParams } from '@components/Dashboard/dashboardSlice/campaignsApi';
import { ExecutiveReportDownloadButton } from './ExecutiveReportDownload';
import {
  buildPresentation,
  useExecutiveReportFields,
} from '@features/executive-report/subdomains/visitation';
import { clientDefaultValues } from '@features/executive-report/subdomains/visitation';

type VisitationExecutiveReportDownloadProps = {
  campaignId: number;
  campaignParams: Omit<GetCampaignParams, 'id'>;
  reportParams: Omit<GetLci3ReportParams, 'id'>;
};

export const VisitationExecutiveReportDownload = ({
  campaignId,
  campaignParams,
  reportParams,
}: VisitationExecutiveReportDownloadProps) => {
  const navigate = useNavigate();

  const { role: userRole } = useCurrentUser();
  const { data, loading } = useExecutiveReportFields({
    campaignParams: { ...campaignParams, id: campaignId },
    reportParams,
  });

  const onClickHandler = () => {
    if (userRole === 'user') {
      if (!data) throw new Error('Missing data for presentation');

      const presentation = buildPresentation({
        ...data,
        brandLogo: null,
        customFields: clientDefaultValues(data.campaign.name),
      });

      void presentationToFile(presentation);
    } else {
      void navigate(
        `/campaigns/${campaignId}/executive-report?${stringify({
          ...campaignParams,
          ...reportParams,
        })}`
      );
    }
  };

  return (
    <ExecutiveReportDownloadButton
      disabled={!data}
      loading={loading}
      onClickHandler={onClickHandler}
    />
  );
};
